const PoliciesText= () => {
    return (
      <>
        <div className="text-box">
          <h3>Introduction</h3>
          <p>
            This page states the terms and conditions under which you may use
            www.myorins.co.za. Please read this page carefully. By using this
            website, you are showing your acceptance to be bound by these terms
            and conditions. Origins Personnel may revise these terms and
            conditions at any time by updating this page. You should visit this
            page periodically to review these. “You” and “User” as used herein to
            refer to all individuals and/or entities accessing this website for
            any reason.{" "}
          </p>
        </div>
  
        <div className="text-box">
          <h3>General Rules</h3>
          <p>
            Users may not use the website in order to transmit, distribute, store
            or destroy material in violation of any applicable law or regulation
            in a manner that will infringe the copyright, trademark, trade secret
            or other intellectual property rights of others or violate the
            privacy, publicity or other personal rights of others in a way that is
            defamatory, obscene, threatening, abusive or hateful.{" "}
          </p>
        </div>
  
        <div className="text-box">
          <h3>Copyright and Intellectual Property Rights</h3>
          <p>
            All rights in/to the content of this website are reserved and retained
            by the owners of such rights. Users of this website are not granted a
            license or any other right including without limitation under
            Copyright, Trade Mark, Patent or Intellectual Property Rights in/or to
            the content.{" "}
          </p>
        </div>
  
        <div className="text-box">
          <h3>Security Rules</h3>
          <p>
            Users are prohibited from violating or attempting to violate the
            security of the Website, including, but without limitation: accessing
            data not intended for such user or logging into a server or account
            which the user is not authorized to access; attempting to probe, scan
            or test the vulnerability of a system or network or to breach security
            or authentication measures; attempting to interfere with service to
            any user, host or network, including, without limitation, via means of
            submitting a virus to the website, overloading, “flooding”,
            “spamming”, “mailbombing” or “crashing”; sending unsolicited email,
            including promotions and/or advertising of products or services;
            forging any IP packet header or any part of the header information in
            any email or newsgroup posting; deleting or revising any material
            posted by any other person or entity; using any device, software or
            routine to interfere or attempt to interfere with the proper working
            of this website or any activity being conducted on this site.{" "}
          </p>
          <p>
            Violations of system or network security may result in civil or
            criminal liability. Afro Ant may involve, and cooperate with, law
            enforcement authorities in prosecuting users who are involved in such
            violations.{" "}
          </p>
        </div>
  
        <div className="text-box">
          <h3>Disclaimer</h3>
          <p>
            Origins Personnel is not to be considered to be a Recruiter and/or
            Employer with respect to the use of the website and shall not be
            responsible for any user entering into any agreements or making
            decisions of whatever nature resulting from the posting of jobs, CV’s
            and/or any other information obtained on the website..{" "}
          </p>
          <p>
            Origins Personnel does not claim that the website will operate
            error-free or that the website and its server are free of computer
            viruses or other harmful mechanisms. If your use of the website or the
            material results in the need for servicing or replacing equipment or
            data, Afro Ant will not be responsible for those costs or any
            consequential losses as a result thereof.{" "}
          </p>
          <p>
            The website and material are provided on an “as is” basis without any
            warranties of whatsoever nature, whether express or implied, including
            the warranty of merchantability, quality, fitness for particular
            purpose and non-infringement, the accuracy, reliability, completeness
            or timeliness of the material, services, software, text, graphics and
            links set out on the website.{" "}
          </p>
          <p>
            Origins Personnel, its suppliers, or any third parties referred to on
            this website will under no conditions be liable for any damages of
            whatsoever nature, whether for bodily, moral or material injury
            (including, without limitation, indirect, punitive, incidental and
            consequential damages, lost profits, or damages resulting from lost
            data or business interruption) resulting from the use or inability to
            use the website and the material, whether based on warranty,
            contractual or extra-contractual liability, or any other legal
            matters.{" "}
          </p>        
         
        </div>
      </>
    );
  };
  
  export default PoliciesText;
  